import { computed, reactive } from '@vue/composition-api';
import { JOHAISETSU_TYPE_GROUP_TOUKETSU_BOUSHI_SAGYOU } from '@/consts/johaisetsu_car';
import { filterJohaisetsuTypesByGroup } from '@/lib/johaisetsu/johaisetsuHelper';
import { useJohaisetsuSagyouContext } from '@/components/Sp/Johaisetsu/composables/useJohaisetsuSagyouContext';
import { UseSettouSagyouParams, UseSettouSagyouResult } from '@/components/Sp/Johaisetsu/types';

interface State {
  selectedJohaisetsuType: string | null;
}

export default function useSettouSagyou(params: UseSettouSagyouParams): UseSettouSagyouResult {
  const state = reactive<State>({
    selectedJohaisetsuType: params.selectedJohaisetsuType,
  });
  const settouSagyou = useJohaisetsuSagyouContext();
  const johaisetsuTypeGroupName = settouSagyou.johaisetsuTypeGroupName;
  const showSanpuNum = settouSagyou.johaisetsuTypeGroup === JOHAISETSU_TYPE_GROUP_TOUKETSU_BOUSHI_SAGYOU;
  const johaisetsuTypeMap = window.johaisetsuMaster.johaisetsuTypeMap;
  const johaisetsuTypes = filterJohaisetsuTypesByGroup(settouSagyou.johaisetsuTypeGroup);
  const johaisetsuTypeNameDisp = computed<string>(() => {
    let ret = '';
    if (johaisetsuTypes.length >= 1) {
      const johaisetsuTypeObj = johaisetsuTypeMap[state.selectedJohaisetsuType || ''];
      ret = johaisetsuTypeObj ? johaisetsuTypeObj.work_type : '';
    }
    return ret;
  });

  const setJohaisetsuType = (johaisetsuType: string) => {
    state.selectedJohaisetsuType = johaisetsuType;
  };

  return {
    state,
    johaisetsuTypeGroupName,
    johaisetsuTypeNameDisp,
    johaisetsuTypeMap,
    johaisetsuTypes,
    showSanpuNum,
    setJohaisetsuType,
  };
}
